import createCachedSelector from 're-reselect';

import { getStakeSlots } from 'app/lib/betting/getStakeSlots';

export default (
  matchSportId,
  matchStakesSelector,
  matchInnerLineListSelector,
) => {
  // этот селектор создан для ВРЕМЕННОЙ СТРАНИЦЫ
  // после рейстайла страницы матча, удалить
  const invisibleStakesSelector = createCachedSelector(
    (state, lineId, matchId) => matchStakesSelector(state, matchId),
    (state, lineId, matchId) => (
      matchInnerLineListSelector(state, matchId).find((line) => line.id === lineId) || null
    ),
    /**
       * @param {Immutable.List<StakeEntity>} stakes
       * @param {?InnerLineEntry} line
       */
    (stakes, line) => {
      return line?.stakeIds.map((stakeId) => stakes.get(stakeId));
    },
  )((state, lineId, matchId) => `${matchId}.${lineId}`);

  // этот селектор создан для ВРЕМЕННОЙ СТРАНИЦЫ
  // после рейстайла страницы матча, удалить
  return createCachedSelector(
    (state, lineId) => lineId,
    (state, lineId, matchId) => invisibleStakesSelector(state, lineId, matchId),
    (state, lineId, matchId) => matchSportId(state, { matchId }),
    /**
       * @param {number} lineId
       * @param {Immutable.List<StakeEntity>} stakes
       * @param {number} sportId
       */
    (lineId, stakes, sportId) => {
      return getStakeSlots({ lineId, stakes, sportId });
    },
  )((state, lineId, matchId) => `${matchId}.${lineId}`);
};
